import React from "react";

const OrderTimeContext = React.createContext();

export const OrderTimeProvider = OrderTimeContext.Provider;
export const OrderTimeConsumer = OrderTimeContext.Consumer;

export default OrderTimeContext;
